import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0050',
    ecrans: ['00-2'],
    params: ['id', '?prucleint', '?vaesysnatctb', '?annfindeb']
});
